export default {
    ALL: 'ALL',
    WITH: 'WITH',
    WITHOUT: 'WITHOUT'
};
